import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, Arial, sans-serif',
    h1: {
      fontFamily: 'Poppins',
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'Poppins',
      fontWeight: 600,
    },
    h3: {
      fontFamily: 'Poppins',
      fontWeight: 500,
    },
    h4: {
      fontFamily: 'Poppins',
      fontWeight: 500,
    },
    h5: {
      fontFamily: 'Poppins',
      fontWeight: 400,
    },
    h6: {
      fontFamily: 'Poppins',
      fontWeight: 400,
    },
    body1: {
      fontFamily: 'Poppins',
      fontWeight: 400,
    },
    body2: {
      fontFamily: 'Poppins',
      fontWeight: 400,
    },
  },
  palette: {
    mode: 'light',
  },
});

const darkTheme = createTheme({
  typography: {
    fontFamily: 'Poppins, Arial, sans-serif',
    h1: {
      fontFamily: 'Poppins',
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'Poppins',
      fontWeight: 600,
    },
    h3: {
      fontFamily: 'Poppins',
      fontWeight: 500,
    },
    h4: {
      fontFamily: 'Poppins',
      fontWeight: 500,
    },
    h5: {
      fontFamily: 'Poppins',
      fontWeight: 400,
    },
    h6: {
      fontFamily: 'Poppins',
      fontWeight: 400,
    },
    body1: {
      fontFamily: 'Poppins',
      fontWeight: 400,
    },
    body2: {
      fontFamily: 'Poppins',
      fontWeight: 400,
    },
  },
  palette: {
    mode: 'dark',
  },
});

export { theme, darkTheme };